import React from 'react';
import { Redirect } from 'react-router-dom';
import GlobalData from '../context/globaldata';
import firebase from "firebase/app";
import "firebase/auth";

class Login extends React.Component {
  static contextType = GlobalData;

  state = {
    brew: {},
    brewId: null,
    redirectToReferrer: false
  }

  componentDidUpdate() {
    if(localStorage.getItem('expectSignIn')) {
      this.setState({
        redirectToReferrer: true
      });
    }
  }

  authenticateWithPopup = (component, provider) => {
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then(() => {
      firebase.auth().signInWithRedirect(provider);

      return firebase.auth().getRedirectResult().then((result) => {
        var user = result.user;

        component.setState({
          user: user,
          redirectToReferrer: true
        });
      }).catch((error) => {
        this.context.addNotification('Login error', 'There was a problem while trying to log in, please try again later.', 'danger', 'right', 'bottom-center');
      });
    })
  };

  render() {
    let { from } = this.props.location.state || { from: { pathname: "/" } };
    let { redirectToReferrer } = this.state;
    if (redirectToReferrer) return <Redirect to={ from.pathname } />;
    return (
      <div className="login">
        <div className="login__column login__column--left">
          <h1 className="login__heading">Coffee Journal</h1>
          <h3>Add, review and duplicate past brews. View and recreate other barista's brews.</h3>
          <p>Coffee Journal is currently still in beta, expect bugs and missing features.</p>
          <p>Follow the roadmap here: <a href="https://github.com/gideonheilbron/coffee-journal-issues">Github</a></p>
          <div className="login__box">
            <button className="button button--login" onClick={() => { this.authenticateWithPopup(this, this.props.provider); }} title="Sign in with Google"></button>
          </div>
          <div className="login__footer">
            <ul>
              <li>
                <a href="/">Privacy policy</a>
              </li>
              <li>
                <a href="/">Help</a>
              </li>
              <li>
                <a href="/">Contact</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="login__column login__column--right"></div>
      </div>
    );
  }
}

export default Login;
